import { ReactComponent as UKFlag } from 'assets/icons/flag/uk-flag.svg';
import { ReactComponent as PolandFlag } from 'assets/icons/flag/poland-flag.svg';
import { ReactComponent as GermanFlag } from 'assets/icons/flag/german-flag.svg';
import { ReactComponent as CzechFlag } from 'assets/icons/flag/czech-flag.svg';

export { UKFlag, PolandFlag, GermanFlag, CzechFlag };

export const LANGUAGE_FLAG_MAP = {
	pl: PolandFlag,
	en: UKFlag,
	de: GermanFlag,
	cs: CzechFlag,
} as const;
